export default function Footer() {
  return (
    <footer className="bg-stone-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex flex-col sm:flex-row items-center justify-between gap-2">
        <span className="text-sm text-gray-400">&copy; {new Date().getFullYear()} DURID d.o.o. All rights reserved.</span>
        <span className="text-sm text-gray-400">iOS App Development &mdash; Slovenia</span>
      </div>
    </footer>
  );
}
